import React, { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import DialogContentModal from "../components/DialogContent";
import ApplicaionFormatView from "../../Forms/ApplicationView";
import NOCFormatView from "../../Forms/NOCFormatView";

const Structural = ({ formData ,applicationDocs,totalAmount}) => {
    let user = Digit.UserService.getUser();
    const [smShow, setSmShow] = useState(false);
    const [smShowNoc, setSmShowNoc] = useState(false);
    const { t } = useTranslation();
    return (
        <React.Fragment>
           <div style={{ backgroundColor: "rgba(173, 229, 232, 0.69)" , padding:"10px"}}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)">
          <Box gridColumn="span 3" sx={{ml:2}}>
            <b>{t(`BPA_APPLICATION_NUMBER_LABEL`)}</b>
          </Box>
          <Box gridColumn="span 3" sx={{ml:2}}>
            : &nbsp;&nbsp; {formData?.applicationNo || ""}
          </Box>
          <Box gridColumn="span 3" sx={{ml:2}}>
          {formData?.applicationType === "FORM_NOC" && (
              <button
                className="btn btn-primary"
                style={{padding:"1px"}}
                onClick={() => {
                  setSmShowNoc(true),
                    console.log("modal open")
                }}
              >
                View Application
              </button>
            )}
            {formData?.applicationType !== "FORM_NOC" && (
              <button
                className="btn btn-primary"
                style={{padding:"1px"}}
                onClick={() => {
                  setSmShow(true),
                    console.log("modal open")
                }}
              >
                View Application
              </button>
            )}
          </Box>
          <Box gridColumn="span 3" sx={{ml:2}}></Box>
          <Box gridColumn="span 3" sx={{ml:2}}>
            <b>Mobile Number</b>
          </Box>
          <Box gridColumn="span 9" sx={{ml:2}}>
            {formData?.landInfo?.owners && formData?.landInfo?.owners?.map((ob, index) => (
              <div>
                : &nbsp;&nbsp; {ob?.mobileNumber}
              </div>
            ))}
          </Box>
          <Box gridColumn="span 3" sx={{ml:2}}>
            <b>Applicant Name</b>
          </Box>
          <Box gridColumn="span 9" sx={{ml:2}}>
            {formData?.landInfo?.owners && formData?.landInfo?.owners?.map((ob, index) => (
              <div>
                : &nbsp;&nbsp; {ob?.name}
              </div>
            ))}
          </Box>
          <Box gridColumn="span 3" sx={{ml:2}}>
            <b>Applied For </b>
          </Box>
          <Box gridColumn="span 9" sx={{ml:2}}>
            : &nbsp;&nbsp; {t(`${formData?.applicationType}`)}
          </Box>
          {/* <Box gridColumn="span 3" sx={{ml:2}}>
            <b>Form </b>
          </Box>
          <Box gridColumn="span 9" sx={{ ml: 2 }}>
          {formData?.applicationType === "FORM_11" &&(
            <React.Fragment>
              : &nbsp;&nbsp; Permission for Development/ Subdivision of Land.
            </React.Fragment>
            )}
             {formData?.applicationType === "FORM_26" &&(
            <React.Fragment>
              : &nbsp;&nbsp;   Form of application for composition of offences under section
          39-C read with sub-section (3) of section 39 of the Himachal
          Pradesh  Act, 1977 (Act no. 12 of 1977)..
            </React.Fragment>
             )}
             {formData?.applicationType === "FORM_CLU" &&(
            <React.Fragment>
              : &nbsp;&nbsp;   Change of Land Use
            </React.Fragment>
             )}
              {formData?.applicationType === "FORM_16" &&(
            <React.Fragment>
              : &nbsp;&nbsp;   Form of Application for Appeal. This Form 16 (Application of Appeal) comes under Rule 22.
            </React.Fragment>
             )}
              {formData?.applicationType === "FORM_MT" &&(
            <React.Fragment>
              : &nbsp;&nbsp;  Mobile tower application is used to taking permission for installing the Mobile tower in the premises of TCP, SADA and UD departments.
            </React.Fragment>
             )}
          </Box> */}
          </Box>
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShow}
            onClose={() => { setSmShow(false) }}
          >
            <ApplicaionFormatView
              formData={formData}
              applicationDocs={applicationDocs}
              totalAmount={totalAmount}
            />
          </DialogContentModal>
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowNoc}
            onClose={() => { setSmShowNoc(false) }}
          >  
        <NOCFormatView
          formData={formData}
          applicationDocs={applicationDocs}
          totalAmount={totalAmount}
        />
          </DialogContentModal>

      </div>
         </React.Fragment>
    )
}
export default Structural;